import React, { useState, useEffect } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import Select from 'react-select';

import { GET, POST, newFetch } from '../../../../helpers/fetch';

import LayoutContext from '../../../../store/Layout/contexts';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../components/SweetAlert';

const AddTTGroup = ({
  history,
  match: {
    params: { client_id, site_id },
  },
}) => {
  const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  };

  const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    color: '#172B4D',
    display: 'inline-block',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
  };

  const formatGroupLabel = (data) => (
    <div style={groupStyles}>
      <span>{data.label}</span>
      <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
  );

  const [groupedOptions, setGroupedOptions] = useState([
    {
      label: 'Admins',
      options: [],
    },
    {
      label: 'Supervisors',
      options: [],
    },
  ]);

  const [site, setSite] = useState(null);
  const [groupName, setGroupName] = useState('');

  const [admins, setAdmins] = useState([]);
  const [selectedAdmins, setSelectedAdmins] = useState([]);
  const [supervisors, setSupervisors] = useState([]);
  const [selectedSupervisors, setSelectedSupervisors] = useState([]);

  const [incidents, setIncidents] = useState([]);
  const [selectedIncidents, setSelectedIncidents] = useState([]);

  useEffect(() => {
    const fetchSite = async () => {
      let api_path = `/client/${client_id}/site/${site_id}`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setSite(response.data);
      } else {
        ToastUtil.error(response.message);
        history.goBack();
      }
    };

    if (client_id && site_id) fetchSite();
  }, [client_id, site_id]);

  useEffect(() => {
    const fetchIncidents = async () => {
      let api_path = `/tt/incident`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setIncidents(response.data);
      } else {
        ToastUtil.error(
          `${response.message}. Please create incidents to continue.`
        );
        history.goBack();
      }
    };

    fetchIncidents();
  }, []);

  useEffect(() => {
    const fetchAdmins = async () => {
      let api_path = `/admin/admins`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        let filtered = response.data.filter((admin) =>
          admin.client_admins.some(
            (client) => client.client_id === parseInt(client_id)
          )
        );
        setAdmins(filtered);
      }
    };

    const fetchSupervisors = async () => {
      let api_path = `/supervisor`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        let filtered = response.data.filter((supervisor) =>
          supervisor.sites.some((site) => site.id === parseInt(site_id))
        );
        setSupervisors(filtered);
      }
    };

    if (site_id) {
      fetchAdmins();
      // fetchSupervisors();
    }
  }, [site_id]);

  useEffect(() => {
    var clone = JSON.parse(JSON.stringify([...groupedOptions]));

    if (admins.length > 0) {
      clone[0].options = [...admins].map((admin) => ({
        is_admin: true,
        objValue: admin,
        value: `admin-${admin.id}`,
        label: `${admin.first_name} ${admin.last_name}`,
      }));
    }

    if (supervisors.length > 0) {
      clone[1].options = [...supervisors].map((supervisor) => ({
        is_supervisor: true,
        objValue: supervisor,
        value: `supervisor-${supervisor.id}`,
        label: `${supervisor.first_name} ${supervisor.last_name}`,
      }));
    }

    setGroupedOptions(clone);
  }, [admins, supervisors]);

  const setSelected = (values) => {
    if (values) {
      var selectedAdminsValue = [];
      var selectedSupervisorsValue = [];

      for (let value of values) {
        value.is_admin && selectedAdminsValue.push(value.objValue.id);
        value.is_supervisor && selectedSupervisorsValue.push(value.objValue.id);
      }

      setSelectedAdmins(selectedAdminsValue);
      setSelectedSupervisors(selectedSupervisorsValue);
    }
  };

  const checkboxHandler = (e) => {
    if (e.target.checked) {
      let updatedSelectedIncidents = [...selectedIncidents];

      updatedSelectedIncidents.push(parseInt(e.target.value));
      setSelectedIncidents(updatedSelectedIncidents);
    } else {
      let updatedSelectedIncidents = [...selectedIncidents].filter(
        (id) => id !== parseInt(e.target.value)
      );

      setSelectedIncidents(updatedSelectedIncidents);
    }
  };

  const discardHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?'
      )
    ) {
      setGroupName('');
      setSelectedAdmins([]);
      setSelectedSupervisors([]);
      setSelectedIncidents([]);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!groupName) {
      ToastUtil.error('Please enter TT Group Name!');
      return false;
    }

    if (selectedAdmins.length <= 0 && selectedSupervisors.length <= 0) {
      ToastUtil.error('Please select Users!');
      return false;
    }

    if (selectedIncidents.length <= 0) {
      ToastUtil.error('Please select Incidents!');
      return false;
    }

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to create this TT Group?'
      )
    ) {
      let data = {
        name: groupName,
        admins: selectedAdmins,
        supervisors: selectedSupervisors,
        incidents: selectedIncidents,
      };

      let api_path = `/site/${site_id}/ttgroup`;
      let response = await newFetch(POST, api_path, data);

      ToastUtil.success(response.message);

      response.success &&
        history.push(`/clients/client/${client_id}/sites/site/${site_id}`);
    }
  };
  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div style={{ paddingTop: '3rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to={`/clients/client/${client_id}/sites/site/${site_id}`}
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div>
                <i className="fas fa-chevron-left pe-2"></i> {site && site.name}
              </div>
            </NavLink>
            <div className="pt-4">
              <h3>Create New TT Group</h3>
            </div>
          </div>
          <form onSubmit={(e) => submitHandler(e)}>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>TT Group Information</strong>
                <br />
                <small className="pt-2 text-muted">
                  Manage TT Group information
                </small>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <div className="mb-2">
                  <label htmlFor="ttGroupName">TT Group Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="ttGroupName"
                    placeholder="e.g. SIN10"
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Assign Users</strong>
                <br />
                <small className="pt-2 text-muted">
                  Manage and assign users to this TT Group
                </small>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <Select
                  isMulti
                  isClearable
                  isSearchable
                  name="users"
                  formatGroupLabel={formatGroupLabel}
                  options={groupedOptions}
                  onChange={(values) => setSelected(values)}
                />
              </div>
            </div>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
                marginBottom: '6rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Tag Incidents</strong>
                <br />
                <small className="pt-2 text-muted">
                  Assigned users will be notified whenever a ticket is raised
                  regarding specific incidents
                </small>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <div className="d-flex flex-column">
                  <div className="row border-bottom mb-2 pb-2 mx-1">
                    <div className="col-1 p-0 fw-bold">SEV</div>
                    <div className="col-10 p-0 fw-bold">Incidents</div>
                    <div className="col-1 p-0 text-center fw-bold">Select</div>
                  </div>
                  {incidents &&
                    incidents.length > 0 &&
                    incidents.map((incident) => (
                      <label
                        key={incident.id}
                        className="row py-2"
                        htmlFor={`ttGroupIncident-${incident.id}`}
                      >
                        <div className="col-1 text-center">
                          <span className="badge rounded-pill text-bg-light py-2 px-3">
                            {incident.sev_id}
                          </span>
                        </div>
                        <div className="col-10">{incident.name}</div>
                        <div className="col-1 text-center">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value={incident.id}
                            onChange={(e) => checkboxHandler(e)}
                            id={`ttGroupIncident-${incident.id}`}
                          />
                        </div>
                      </label>
                    ))}
                </div>
              </div>
            </div>

            <div
              style={{
                position: 'fixed',
                bottom: 0,
                width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                height: '4.5rem',
                paddingRight: '3rem',
              }}
              className="border-top bg-white d-flex align-items-center justify-content-end"
            >
              <button
                type="button"
                onClick={discardHandler}
                className="btn btn-outline-brand"
                style={{ width: '12rem' }}
              >
                Discard
              </button>
              <button
                type="submit"
                className="btn btn-brand ms-3"
                style={{ width: '12rem' }}
              >
                Save changes
              </button>
            </div>
          </form>
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

export default withRouter(AddTTGroup);
